import { Component, Input, EventEmitter, OnInit, Output, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

interface RecurringShift {
  Date: string;
  'Start Time': string;
  'End Time': string;
  'Unpaid Break' : string;
  'Transit Allowance' : string;
  // Position in the bound form array, and whether this row can be dropped — both
  // set by callers that render an editable list.
  index?: number;
  canRemove?: boolean;
  // Where the row sits inside its own date: only the first row prints the date,
  // and only the last one offers the add button.
  showDate?: boolean;
  canAdd?: boolean;
}

@Component({
  selector: 'app-edit-recurring-shift-list',
  templateUrl: './edit-recurring-shift-list.component.html',
  styleUrls: ['./edit-recurring-shift-list.component.scss'],
})
export class EditRecurringShiftListComponent implements OnInit, OnChanges{
  @Input() data: RecurringShift[] = [];
  @Input() config: string[] = [];
  @Input() formGroup;
  @Input() formGroupName?:string  = "recurringShifts";
  @Input() confirmationView;
  @Input() showEditIcon?: Boolean = true
  @Input() showRequiredAsterisk?: Boolean = false;
  @Input() companyType?: string;
  @Input() settings?: any;
  @Input() currentView?: string;

  /**
   * Extra cssClass for the dropdown popups in these rows, plus a heading taken
   * from the column name. The create-shift page passes 'staffy-select'.
   */
  @Input() interfaceCssClass: string = '';

  // Opt-in: renders the add/remove controls that let one date carry several shifts.
  @Input() showSlotActions?: boolean = false;
  @Output() onToggleCheckBox = new EventEmitter<{ checked: boolean; index: number }>();
  @Output() onToggleAllCheckBoxes = new EventEmitter<{ checked: boolean; index: number }>();
  @Output() addSlot = new EventEmitter<number>();
  @Output() removeSlot = new EventEmitter<number>();

  checkBoxOptions = [{ 
    label: ""
  }]

  constructor(  private changeDetectorRef: ChangeDetectorRef ) {}

  ngOnInit(){
  }

  getControl(index: number){
    return this.formGroup.get(this.formGroupName).controls[index]
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.changeDetectorRef.detectChanges();
  }

  toggleCheckBox(value: boolean, index: number) {
    this.onToggleCheckBox.emit({ checked: value, index });
  }

  toggleAllCheckBoxes(value: boolean, index: number) {
    this.onToggleAllCheckBoxes.emit({ checked: value, index });
  }
 
}

